'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Button2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Button/index.js
// module id = 269
// module chunks = 0